const apikey = {
  xapikey: "CCfUVesk7j4KymP41pTne68mEc74atdm5HJAJVUN"
};

export default apikey;